export const handleStatus = (status: string) => {
  switch (status) {
    case "CREATED":
      return "Cadastrado";

    case "AWAITING_MANUAL_ACCEPTANCE":
      return "Aguardando Aceite";

    case "PENDING":
      return "Aceito - Aguardando Envio";

    case "DONE":
      return "Concluído";

    case "ERROR":
      return "Erro";

    case "REFUSED":
      return "Recusado";

    case "CANCEL":
      return "Cancelado";

    default:
      return "Cadastrado";
  }
};

export const handleStatusColor = (status: string) => {
  switch (status) {
    case "CREATED":
      return "#4CAF50";
    case "AWAITING_MANUAL_ACCEPTANCE":
      return "#FFC107";
    case "PENDING":
      return "#2196F3";
    case "DONE":
      return "#4CAF50";
    case "ERROR":
      return "#F44336";
    case "REFUSED":
      return "#FF5722";
    case "CANCEL":
      return "#BDBDBD";
    default:
      return "#BDBDBD";
  }
};

//(“01” = cível, “02” = criminal, “03” = trabalhista, “04” = fiscal, “05” =
//alimentícia).

export const handleAjudTypeAction = (typeAction: string) => {
  switch (typeAction) {
    case "01":
      return "cível";

    case "02":
      return "criminal";

    case "03":
      return "trabalhista";

    case "04":
      return "fiscal";

    default:
      return "alimentícia";
  }
};
